// extracted by mini-css-extract-plugin
export var brand = "_27-9";
export var button = "_27-0";
export var chevron = "_27-v";
export var chevronButton = "_27-w";
export var content = "_27-n";
export var danger = "_27-g";
export var dangerOutlined = "_27-h";
export var dark = "_27-l";
export var darkTheme = "_27-c";
export var extraSmall = "_27-4";
export var fullWidth = "_27-8";
export var ghost = "_27-d";
export var gray = "_27-t";
export var icon = "_27-p";
export var iconButton = "_27-s";
export var iconButtonBorder = "_27-x";
export var iconButtonBorderDark = "_27-y";
export var iconButtonBorderLight = "_27-z";
export var iconLeft = "_27-q";
export var iconRight = "_27-r";
export var large = "_27-1";
export var light = "_27-m";
export var medium = "_27-2";
export var micro = "_27-5";
export var nano = "_27-7";
export var outlined = "_27-k";
export var pending = "_27-a";
export var primary = "_27-i";
export var shadow = "_27-o";
export var small = "_27-3";
export var solidLight = "_27-e";
export var solidLightBrand = "_27-f";
export var spinner = "_27-u";
export var transparent = "_27-j";
export var warning = "_27-b";
export var wideNano = "_27-6";